/* $Id$ */
// https://www.npmjs.com/package/cropperjs
require('cropperjs/dist/cropper.min.css');
import Cropper from 'cropperjs';

/**
 * A tool for making per-Image-object and per-imager-transformation
 * adjustments to images served by Foundation.
 *
 * To add edit links to every img served via imager on a page, call:
 *
 *     Foundation.Image.Editor.setupEditButtons()
 *
 * Images with an attached edit link will have the 'has-imgeditor-button'
 * class.  This permits incremental button setup and allows for special
 * styling of editable images.
 * @constructor
 * @param {string} imagerUrl
 * @param {function(Foundation.Image)} callback
 */
Foundation.Image.Editor = function (imagerUrl, callback, containerElement) {
  this.image = new Foundation.Image(imagerUrl);
  this.callback = callback;
  this.containerElement = containerElement || jQuery('body');

  const parts = Foundation.Image.parseImagerUrl(imagerUrl);
  this.fieldType = parts.fieldType;
  this.transformation = parts.transformation;
  this.oid = parts.oid;
  this.fileName = parts.fileName;
  this.origUrl = parts.origUrl;

  this.beginModal();

  this.finishedPromise = new Foundation.Promise();
  this.finishedPromise.then(function () {
    this.callback(this.image);
  }.bind(this));
};

/**
 * @public
 * @return {Foundation.Promise}
 */
Foundation.Image.Editor.prototype.finished = function () {
  return this.finishedPromise;
};

/**
 * @private
 */
Foundation.Image.Editor.prototype.beginModal = function () {
  jQuery.ajax({
    url: '/gyrobase/Admin/ImgEditor/ImageInfo',
    data: {
      "oid": this.oid,
      "trans": this.transformation,
      "field_type": this.fieldType,
      "path": this.fileName,
      "origUrl": this.origUrl
    },
    error: this.endModal.bind(this),
    success: this.finishedInfoRequest.bind(this),
  });

  this.chromeColor = 'rgba(0, 0, 0, 0.6)';

  this.editorChrome = jQuery(`<div uk-modal="bg-close: false;"></div>`);
  this.editorChrome.addClass('uk-modal uk-modal-container');

  this.editorView = jQuery(`<div></div>`);
  this.editorView.addClass('imgeditor_view uk-modal-dialog uk-modal-body');
  this.editorView.append('<button class="uk-modal-close-default" type="button" uk-close></button>');

  this.editorChrome.append(this.editorView);
  this.editorChrome.css({ backgroundColor: this.chromeColor });

  window.UIkit.modal(this.editorChrome, { container: this.containerElement}).show();
  jQuery(this.editorChrome).on('hidden', this.endModal.bind(this));
};

/**
 * @private
 * @param {Object=} obj
 * @param {string=} textStatus
 * @param {string=} errorThrown
 */
Foundation.Image.Editor.prototype.endModal = function (jqXHR, textStatus, errorThrown) {
  this.cleanUp();
  if (textStatus && window.console) window.console.error(textStatus, errorThrown, jqXHR);
  this.finished().tryFail();
};

/**
 * @private
 */
Foundation.Image.Editor.prototype.cleanUp = function () {
  this.editorChrome.remove();
  if (this.cropper) this.cropper.destroy();
};

/**
 * @private
 * @param {jQuery.ajax} data
 */
Foundation.Image.Editor.prototype.finishedInfoRequest = function (data) {
  const response = data;
  if (response["status"] !== "success") {
    window.alert(response["msg"].replace(/\s+/g, " "));
    this.endModal();
    return;
  }

  /**
   * @type {string}
   */
  this.oid = response["oid"];

  /**
   * @type {string}
   */
  this.cropCoords = response["cropCoords"];

  /**
   * @type {number}
   */
  this.width = response["width"];

  /**
   * @type {number}
   */
  this.height = response["height"];

  /**
   * @type {{type:string, width:number, height:number}}
   */
  this.constraints = response["constraints"];

  if (this.cropCoords) {
    const regex = /(\d+),\s*(\d+)\s+(\d+),\s*(\d+)/;
    const coords = this.cropCoords.match(regex);
    if (!coords) throw `Bad cropCoords: ${this.cropCoords}`;
    this.origCoords = {
      "x1": parseInt(coords[1], 10), "y1": parseInt(coords[2], 10),
      "x2": parseInt(coords[3], 10), "y2": parseInt(coords[4], 10)
    };
  }

  this.imgIsHorizontal = this.width > this.height;
  if (this.imgIsHorizontal) {
    this.editorChrome.addClass('uk-modal-container');
  }

  this.setupUI();
};

/**
 * @private
 */
Foundation.Image.Editor.prototype.setupUI = function () {
  const imgMaxHeight = window.innerHeight - 300;

  // Create the img element
  if (this.imgIsHorizontal) {
    this.editImg = jQuery(`
      <div class="uk-margin-small" style="width:${this.width}px; max-width:100%; height:auto; max-height:${imgMaxHeight}px; margin-left:auto; margin-right:auto;">
        <img id="cropper-image" src="${this.origUrl}">
      </div>
    `);
  }
  else {
    this.editImg = jQuery(`
      <div class="uk-margin-small" style="width:${this.width}px; max-width:100%; height:${this.height}px; max-height:${imgMaxHeight}px; margin-left:auto; margin-right:auto;">
        <img id="cropper-image" src="${this.origUrl}">
      </div>
    `);
  }

  // Create title element
  this.title = jQuery('<div class="uk-modal-header"></div>')
  this.title.append(`<h2 class="uk-modal-title">Editing "<b>${this.transformation}</b>" Transformation</h2>`)

  this.editorView.append(this.title);
  this.editorView.append(this.editImg);

  // Create placeholder for warning text
  this.warning = jQuery('<div class="uk-alert-warning" uk-alert hidden></div>');

  this.editorView.append(this.warning);

  // Setup the cropper form
  const form = jQuery(`
    <form method="post" action="/gyrobase/Admin/ImgEditor/ImageSave">
      <input type="hidden" name="oid" value="${this.oid}">
      <input type="hidden" name="fieldType" value="${this.fieldType}">
      <input type="hidden" name="trans" value="${this.transformation}">
      <input type="hidden" name="x2" id="imgeditor_x2" value="0">
      <input type="hidden" name="y2" id="imgeditor_y2" value="0">

      <div class="uk-align-center uk-width-5-6 uk-flex uk-flex-center uk-margin-small-top uk-margin-remove-bottom">
        <div class="uk-flex uk-flex-row uk-flex-center">
          <div class="uk-width-1-2 uk-flex uk-flex-column uk-grid-small uk-margin-right" uk-grid>
            <div class="uk-width-1-1 uk-flex uk-flex-row uk-flex-right">
              <div style="width: 130px; text-align: right;">
                <label for="imgeditor_x1" class="uk-form-label">X:</label>
                <input type="text" name="x1" id="imgeditor_x1" size="4" readonly="readonly" class="uk-input uk-form-small uk-form-width-xsmall">
              </div>
              <div style="width: 130px; text-align: right;">
                <label for="imgeditor_y1" class="uk-form-label">Y:</label>
                <input type="text" name="y1" id="imgeditor_y1" size="4" readonly="readonly" class="uk-input uk-form-small uk-form-width-xsmall">
              </div>
            </div>
            <div class="uk-width-1-1 uk-flex uk-flex-row uk-flex-right">
              <div style="width: 130px; text-align: right;">
                <label for="imgeditor_width" class="uk-form-label">Width:</label>
                <input name="width" id="imgeditor_width" size="4" readonly="readonly" class="uk-input uk-form-small uk-form-width-xsmall">
              </div>
              <div style="width: 130px; text-align: right;">
                <label for="imgeditor_height" class="uk-form-label">Height:</label>
                <input name="height" id="imgeditor_height" size="4" readonly="readonly" class="uk-input uk-form-small uk-form-width-xsmall">
              </div>
            </div>
          </div>
          <div class="uk-width-1-2 uk-flex uk-flex-column">
            <div class="uk-width-1-1 uk-flex uk-flex-row uk-grid-small" uk-grid>
              <div class="uk-width-1-2" cropper-button-revert></div>
              <div class="uk-width-1-2" cropper-button-remove></div>
            </div>
            <div class="uk-width-1-1 uk-flex uk-flex-row uk-grid-small" uk-grid>
              <div class="uk-width-1-2" cropper-button-cancel></div>
              <div class="uk-width-1-2" cropper-button-save></div>
            </div>
          </div>
        </div>
      </div>
    </form>`)

  form.on('submit', this.save.bind(this))

  form.find('[cropper-button-revert]').append(Foundation.Image.Editor.Button("Revert", this.revert.bind(this)))
  form.find('[cropper-button-remove]').append(Foundation.Image.Editor.Button("Remove", this.removeCrop.bind(this)))
  form.find('[cropper-button-cancel]').append(Foundation.Image.Editor.Button("Cancel", this.cancel.bind(this)))
  form.find('[cropper-button-save]').append(Foundation.Image.Editor.Button("Save", this.save.bind(this)))

  this.editorView.append(form);

  this.setupCropper(true);
};

/**
 * @private
 * @param {boolean} useOrigCoords
 */
Foundation.Image.Editor.prototype.setupCropper = function (useOrigCoords) {
  let cropperAspectRatio = NaN;
  if (this.constraints.type === "fixed") {
    cropperAspectRatio = this.constraints.width / this.constraints.height;
  }

  const coords = useOrigCoords && this.origCoords ? this.origCoords : null;

  let cropData = null
  if (coords !== null) {
    cropData = {
      x: coords.x1,
      y: coords.y1,
      width: coords.x2 - coords.x1,
      height: coords.y2 - coords.y1,
      rotate: 0,
      scaleX: 1,
      scaleY: 1,
    }
  }

  const image = document.getElementById('cropper-image');
  const myEditorObj = this;
  this.cropper = new Cropper(image, {
    aspectRatio: cropperAspectRatio,
    autoCrop: false,
    dragMode: 'crop',
    movable: false,
    rotatable: false,
    scalable: false,
    viewMode: 1,
    zoomable: false,
    ready () {
      console.log('cropData', cropData, 'ready this', this);
      if (coords !== null) {
        this.cropper.crop();
        this.cropper.setData(cropData);
      }
    },
    crop () {
      const currentCropData = this.cropper.getData(true); // getData(true) rounds to int
      myEditorObj.updateCropCoords({
        x1: currentCropData.x,
        y1: currentCropData.y,
        x2: currentCropData.x + currentCropData.width,
        y2: currentCropData.y + currentCropData.height,
      });
    },
    cropend () {
      const currentCropData = this.cropper.getData(true);
      myEditorObj.updateWarnings({
        width: currentCropData.width,
        height: currentCropData.height
      });
    }
  });

  image.addEventListener('ready', function () {
    if (this.cropper === myEditorObj.cropper) {
      console.log('Cropper setup complete');
    }
  });

  this.updateCropCoords(coords || {});
  this.hasChanged = false;  // Reset hasChanged boolean.
};

/**
 * @private {{x1:number, y1:number, x2:number, y2:number}} coords
 */
Foundation.Image.Editor.prototype.updateCropCoords = function (coords) {
  let dimensions = {};
  if (coords['x2']) {
    dimensions.width = coords['x2'] - coords['x1'];
  } 
  if (coords['y2']) {
    dimensions.height = coords['y2'] - coords['y1'];
  }

  jQuery('#imgeditor_x1').prop('value', coords['x1'] || '0');
  jQuery('#imgeditor_y1').prop('value', coords['y1'] || '0');
  jQuery('#imgeditor_x2').prop('value', coords['x2'] || '0');
  jQuery('#imgeditor_y2').prop('value', coords['y2'] || '0');
  jQuery('#imgeditor_width').prop('value', dimensions.width || '0');
  jQuery('#imgeditor_height').prop('value', dimensions.height || '0');

  this.hasChanged = true;
};

/**
 * @private
 * @param {({width:number, height:number}|Object)} dimensions
 */
Foundation.Image.Editor.prototype.updateWarnings = function (dimensions) {
  if (this.constraints.type === "unknown") return;

  let constraintDim;
  if (this.constraints.type.match(/^(fixed|max|min)$/)) {
    constraintDim = dimensions.width <= dimensions.height ? "width" : "height";
    if (this.constraints.type === "min") {
      constraintDim = constraintDim === "width" ? "height" : "width";
    }
  }
  else if (this.constraints.width) {
    constraintDim = "width"
  }
  else {
    constraintDim = "height";
  }

  const oldWarning = this.warning.text() || "";
  if (dimensions[constraintDim] 
    && dimensions[constraintDim] < this.constraints[constraintDim]) {
    this.warning
  .removeAttr('hidden')
  .html(`Warning: ${constraintDim}s less than ${this.constraints[constraintDim]} will cause upscaling.`);
}
else {
  this.warning
  .attr('hidden', true)
  .html(``);
}

const newWarning = this.warning.text() || "";
if (oldWarning.length === 0 && newWarning.length > 0) {
  jQuery(this.editorChrome).css({
    backgroundColor: '#C15049',
    transition: 'background-color 0.5s'
  });
}
else if (oldWarning.length > 0 && newWarning.length === 0) {
  jQuery(this.editorChrome).css({
    backgroundColor: this.chromeColor,
    transition: 'background-color 0.5s'
  });
}
};

/**
 * @private
 * @param {Event=} e
 */
Foundation.Image.Editor.prototype.revert = function () {
  this.cropper.destroy();
  this.setupCropper(true);
};

/**
 * @private
 * @param {Event=} e
 */
Foundation.Image.Editor.prototype.removeCrop = function () {
  this.cropper.clear();
  // this.setupCropper(false);
};

/**
 * @private
 * @param {Event=} e
 */
Foundation.Image.Editor.prototype.save = function (e) {
  if (e) e.stop();
  let form = this.editorView.find('form');
  let params = {
    x1: parseInt(form.find('[name="x1"]').val(), 10),
    y1: parseInt(form.find('[name="y1"]').val(), 10),
    x2: parseInt(form.find('[name="x2"]').val(), 10),
    y2: parseInt(form.find('[name="y2"]').val(), 10),
    oid: form.find('[name="oid"]').val(),
    fieldType: form.find('[name="fieldType"]').val(),
    trans: form.find('[name="trans"]').val(),
  }
  jQuery.ajax({
    url: form.attr('action'),
    data: params,
    error: this.saveFailed.bind(this),
    success: this.finishedSaveRequest.bind(this),
    method: 'POST',
  })
};

/**
 * @private
 * @param {jQuery.ajax} data
 */
Foundation.Image.Editor.prototype.finishedSaveRequest = function (data) {
  const response = data;
  if (response["status"] === "success") {
    this.image = new Foundation.Image(response["newSrc"]);
    this.image.setDimensions(response["newWidth"], response["newHeight"]);
    this.finished().fulfill();
  }
  else {
    window.alert(`Save failed: ${response["msg"].replace(/\s+/g, " ")}`);
  }
  this.endModal();
};

/**
 * @private
 * @param {jQuery.ajax} data
 */
Foundation.Image.Editor.prototype.saveFailed = function (data) {
  const response = data;
  if (response && response["errors"]) {
    window.alert(`Save failed:\n${response["errors"].join("\n")}`);
  }
  else {
    window.alert(`Save failed. Got ${response.status} from server.`);
  }
  this.endModal();
}

/**
 * @private
 * @param {Event=} e
 */
Foundation.Image.Editor.prototype.cancel = function () {
  const msg = "Exit image editor without saving changes?";
  if (!this.changed() || window.confirm(msg)) {
    this.endModal();
  }
};

/**
 * @private
 * @return {boolean}
 */
Foundation.Image.Editor.prototype.changed = function () {
  if (!jQuery('#imgeditor_x1')[0]) return false;
  if (!this.hasChanged) return false;

  const x1 = parseInt(jQuery("#imgeditor_x1").prop('value'), 10);
  const y1 = parseInt(jQuery("#imgeditor_y1").prop('value'), 10);
  const x2 = parseInt(jQuery("#imgeditor_x2").prop('value'), 10);
  const y2 = parseInt(jQuery("#imgeditor_y2").prop('value'), 10);

  const o = this.origCoords || { "x1": 0, "y1": 0, "x2": 0, "y2": 0 };
  return x1 !== o["x1"] || y1 !== o["y1"] || x2 !== o["x2"] || y2 !== o["y2"];
};

/**
 * @private
 * @param {string} text
 * @param {function(Event=)} action
 * @return {Element}
 */
Foundation.Image.Editor.Button = function (text, action) {
  const buttonElement = jQuery('<button></button>');
  buttonElement
  .text(text)
  .addClass('uk-button uk-button-primary uk-padding-small uk-width-1-1')
  .on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof action === 'function') {
      action();
    }
  })
  return buttonElement;
};

Foundation.Image.Editor.setupEditButtons = function (containerSelector) {
  const myImageEditor = this;
  Foundation.documentReady.then(function () {
    if (typeof containerSelector === 'string' && jQuery(containerSelector).length) {
      myImageEditor.containerElement = jQuery(containerSelector);
    }
    else {
      myImageEditor.containerElement = jQuery('body');
    }
    const myContainerElement = myImageEditor.containerElement;
    jQuery('img[src*="/imager/"],img[data-src*="/imager/"]').each(function () {
      const imgObj = jQuery(this);
      let imgSrc = imgObj.attr('src') || imgObj.attr('data-src');

      if (typeof imgSrc === 'undefined' || imgSrc.match(/\/original\//)) return;
      if (imgObj.closest('.no-foundation-imgeditor, li.memberItem').length) return;
      if (imgObj.hasClass('has-imgeditor-button')) return;

      imgObj.addClass('has-imgeditor-button');

      // uikit lazyloading stashes the original path in the data-src attribute
      // and replaces source with an inline svg value
      if (imgSrc.match(/data:image\/svg\+xml/)) {
        imgSrc = imgObj.attr('data-src');
      }

      const editButton = jQuery('<button>')
      .text('Crop')
      .css({ 'display': 'none', 'position': 'absolute' })
      .addClass('uk-button uk-button-primary')
      .click(function (e) {
        e.preventDefault()
        editButtonObj.hide()
        new Foundation.Image.Editor(imgSrc, function (fdnImgObj) {
          imgObj
            .attr('src', fdnImgObj.url())
            .attr('srcset', '')
            .width(imgObj.width())
            .css('height', 'auto')
        }, myContainerElement);
      });

      const editButtonObj = editButton.appendTo(myContainerElement);

      let highestZ = 1;
      imgObj.parentsUntil('html').each(function () { 
        let currentZ = parseInt(jQuery(this).css('z-index'));
        if (currentZ) {
          highestZ = Math.max(highestZ, currentZ + 1);
        }
      })

      const stickButtonToImg = function () {
        editButtonObj.css({
          'z-index': highestZ,
          'top': `${imgObj.offset().top + 3}px`,
          'left': `${imgObj.offset().left + 3}px`,
        });
      }

      imgObj.closest('div, a, li, button').hover( function () {
        editButtonObj.show();
      }, function (e) {
        if ((e.relatedTarget || e.toElement) !== editButtonObj[0]) {
          editButtonObj.hide();
        }
      })

      imgObj.closest('div, a, li').on('mouseover', stickButtonToImg);
      jQuery(window).on('resize scroll', stickButtonToImg);
    });
  });
};

window["Foundation"]["Image"]["Editor"] = Foundation.Image.Editor;

// Backwards compatibility.
window["Foundation"]["ImgEditor"] = Foundation.Image.Editor;
window["Foundation"]["ImgEditor"]["setupEditButtons"] = Foundation.Image.Editor.setupEditButtons;

// ---------------------------------------------------------------------
/* eslint eqeqeq: "off" */
